import React, { useState, useRef, useEffect } from "react";
import "../Bfsi Solution/faq.css";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const answerRefs = useRef([]);

  const faqs = [
    {
      q: "What Services Does Your Doctors’ Software Development Company Offer?",
      a: "We offer comprehensive software development services tailored for healthcare professionals, including electronic health record (EHR) systems, appointment scheduling, telemedicine solutions, and more.",
    },
    {
      q: "Can You Develop Custom Software for Managing Electronic Health Records (Ehr)?",
      a: "Yes, we specialize in developing customized EHR systems to digitize patient records, streamline workflows, and enhance overall healthcare management.",
    },
    {
      q: "How Do You Ensure the Security and Confidentiality of Patient Data in Your Software Solutions?",
      a: "We prioritize data security and adhere to industry standards, including HIPAA compliance. Our solutions include robust encryption, secure authentication, and access controls.",
    },
    {
      q: "Can Your Software Integrate With Existing Medical Systems and Technologies Used by Healthcare Providers?",
      a: "Absolutely. Our software solutions are designed for seamless integration with existing medical systems, laboratory information systems (LIS), and other healthcare technologies.",
    },
    {
      q: "Do You Provide Telemedicine Solutions for Virtual Consultations and Remote Patient Care?",
      a: "Yes, we specialize in developing telemedicine solutions that enable secure video consultations, virtual visits, and remote healthcare services.",
    },
    {
      q: "Can Your Software Be Customized to Meet the Specific Needs and Workflows of Our Medical Practice?",
      a: "Certainly. We conduct thorough consultations to understand the unique requirements of your medical practice and customize the software accordingly.",
    },
    {
      q: "How Do You Handle Data Migration for Practices Transitioning to Your Software From Existing Systems?",
      a: "We have a structured data migration process to ensure a smooth transition. We work closely with clients to migrate data securely and accurately.",
    },
    {
      q: "What Measures Do You Take to Ensure the User-friendliness of Your Software for Healthcare Professionals?",
      a: "User experience (UX) is a key focus in our development process. We conduct usability testing and gather feedback to optimize the software interface for healthcare professionals.",
    },
    {
      q: "Do You Provide Training and Support for Healthcare Professionals Using Your Software?",
      a: "Yes, we offer training sessions and ongoing support to ensure healthcare professionals are well-versed in using the software effectively.",
    },
    {
      q: "Can Your Software Help With Managing Appointments, Scheduling, and Improving Overall Practice Efficiency?",
      a: "Absolutely. Our software includes features for appointment scheduling, calendar management, and workflow optimization to enhance practice efficiency.",
    },
  ];

  const toggleFaq = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  // Get height for smooth animation
  const getHeight = (index) => {
  const el = answerRefs.current[index];
  if (!el) return "0px";

  const padding = 40; // top 20 + bottom 20
  return `${el.scrollHeight + padding}px`;
};


  return (
    <div className="faq-wrapper">
      <h2 className="faq-title">Faq's</h2>

      {faqs.map((item, index) => (
        <div
          className={`faq-item ${activeIndex === index ? "active" : ""}`}
          key={index}
        >
          <div className="faq-question" onClick={() => toggleFaq(index)}>
            <span>{item.q}</span>
            <span className="faq-icon">
              {activeIndex === index ? "−" : "+"}
            </span>
          </div>

          {/* Smooth answer */}
          <div
            className="faq-answer"
            ref={(el) => (answerRefs.current[index] = el)}
            style={{
              maxHeight: activeIndex === index ? getHeight(index) : "0px",
            }}
          >
            <p>{item.a}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Faq;
